

















import { SdsBadge } from '@superbet-group/web.lib.ui-components';
import {
    defineComponent,
    PropType,
} from '@vue/composition-api';

export default defineComponent({
    name: 'SuperBonusBadge',
    props: {
        percentage: {
            type: Number,
            required: true,
        },
        size: {
            type: String as PropType<'md' | 'lg'>,
            required: false,
            default: 'lg',
        },
    },
    components: {
        SdsBadge,
    },
});
